import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";
import { PageBreadcrumb } from "../../components/breadcrumb/Breadcrumb.comp";
import { MessageHistory } from "../../components/message-history/MessageHistory.comp";
import { UpdateTicket } from "../../components/update-ticket/UpdateTicket.comp";
import Dropdown from "react-bootstrap/Dropdown";
import { useParams } from "react-router-dom";
import "./Ticket.page.css";
import {
  fetchSingleTicket,
  closeTicket,
  openTicket,
  inProgressTicket,
  underReviewTicket
} from "../ticket-list/ticketsAction";
import { resetResponseMsg } from "../ticket-list/ticketsSlice";

export const Ticket = (props) => {
  const { tId } = useParams();
  const dispatch = useDispatch();
  const {
    isLoading,
    error,
    selectedTicket,
    replyMsg,
    replyTicketError,
  } = useSelector((state) => state.tickets);
  useEffect(() => {
    console.log(tId);
    dispatch(fetchSingleTicket(tId));

    return () => {
      (replyMsg || replyTicketError) && dispatch(resetResponseMsg());
    };
  }, [tId, dispatch, replyMsg, replyTicketError]);
  console.log(tId);
  return (
    <Container>
      <Row>
        <Col>
          <PageBreadcrumb page="Ticket" />
        </Col>
      </Row>
      <Row>
        <Col>
          {selectedTicket.status === "Closed" ? (
            <div className="statusbarOpen">
              TICKET IS: <b>{selectedTicket.status}</b> | Ref ID:{" "}
              <b>[{selectedTicket._id}]</b>
            </div>
          ) : (
            <div className="statusbarClosed">
              {" "}
              TICKET IS: <b>{selectedTicket.status}</b> | Ref ID:{" "}
              <b>[{selectedTicket._id}]</b>
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          {isLoading && <Spinner variant="primary" animation="border" />}
          {error && <Alert variant="danger">{error}</Alert>}
          {replyTicketError && (
            <Alert variant="danger">{replyTicketError}</Alert>
          )}
          {replyMsg && <Alert variant="success">{replyMsg}</Alert>}
        </Col>
      </Row>

      <Row>
        <Col className="text-weight-bolder text-secondary">
          <div className="customer">
            Customer Name: <b>{selectedTicket.customerName}</b>
          </div>
          <div className="company">
            End User: <b>{selectedTicket.companyName}</b>
          </div>
          <div className="customer">
            Transmitter:{" "}
            <b>{selectedTicket.transmitter == true ? "Yes" : "No"}</b>
          </div>
          <div className="customer">
            Receiver: <b>{selectedTicket.receiver == true ? "Yes" : "No"}</b>
          </div>
        </Col>
        <Col className="text-weight-bolder text-secondary">
          <div className="customer">
            Serial Number: <b>{selectedTicket.serialNumber}</b>
          </div>
          <div className="customer">
            eprom Serial Number: <b>{selectedTicket.epromSerialNumber}</b>
          </div>
          <div className="customer">
            Shipped with battery:{" "}
            <b>{selectedTicket.battery == true ? "Yes" : "No"}</b>
          </div>
          <div className="customer">
            Shipped with Eprom:{" "}
            <b>{selectedTicket.eprom == true ? "Yes" : "No"}</b>
          </div>
        </Col>
        <Col className="text-right">
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              {selectedTicket.status}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => dispatch(closeTicket(tId))}>
                Close
              </Dropdown.Item>
              <Dropdown.Item onClick={() => dispatch(openTicket(tId))}>
                Open
              </Dropdown.Item>
              <Dropdown.Item onClick={() => dispatch(inProgressTicket(tId))}>
                In Progress
              </Dropdown.Item>
              <Dropdown.Item onClick={() => dispatch(underReviewTicket(tId))}>
                Under Customer Review
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col className="text-weight-bolder text-secondary">
          <div className="date">
            <b>
              Ticket Opened:{" "}
              {selectedTicket.openAt &&
                new Date(selectedTicket.openAt).toLocaleString()}
            </b>
          </div>
          <div className="status">
            Status: <b>{selectedTicket.status}</b>
          </div>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="status">
            Description: {selectedTicket.description}
          </div>
        </Col>
      </Row>
      <hr />

      <Row className="mt-4">
        <Col>
          {selectedTicket.conversations && (
            <MessageHistory msg={selectedTicket.conversations} />
          )}
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <UpdateTicket _id={tId} />
        </Col>
      </Row>
    </Container>
  );
};
